import { render, staticRenderFns } from "./PFRecommend.vue?vue&type=template&id=611871e6"
import script from "./PFRecommend.vue?vue&type=script&lang=js"
export * from "./PFRecommend.vue?vue&type=script&lang=js"
import style0 from "./PFRecommend.vue?vue&type=style&index=0&id=611871e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports